module.exports = __webpack_public_path__ + "assets/img/17_943_big.7b78abcb.jpg";